Vue.directive('shrink', {
	bind(el) {
		let scrollTop = 0;

		$(window).scroll(function() {
			scrollTop = $(window).scrollTop();

			if (scrollTop >= 100) {
				$(el).addClass('scrolled-nav');
			} else {
				$(el).removeClass('scrolled-nav');
				$(el).css('height', $(el).find('.container').first().outerHeight(true) + 'px')
			}
		});

		$(window).resize(function() {
			$(el).css('height', '');
			$('div#app').css('padding-top', '')

			$(el).css('height', el.offsetHeight + 'px')
			$('div#app').css('padding-top', el.offsetHeight + 'px')
		})
	},
	inserted(el, binding) {
		$(el).css('height', el.offsetHeight + 'px')
		$('div#app').css('padding-top', el.offsetHeight + 'px')

		let f = function (evt) {
			let start = $('button.navbar-toggler').attr('aria-expanded');
			$(el).one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
				function(event) {
					if (start === 'true' && $(el).hasClass('scrolled-nav')) {
						$('.navbar-toggler').addClass('collapsed')
						$('.navbar-collapse').removeClass('show')
						$('.navbar-toggler').attr('aria-expanded', 'false')
					}
				});
		}
		window.addEventListener('scroll', f)

		$(".nav-scrollactive-item").on('click', function(e) {
			e.preventDefault();

			let target = $(this).attr('href')
	        $('html, body').animate({
	            scrollTop: $(target).offset().top - 80
	        }, 1000);
		})

		$("#scrollTop").on('click', function(e) {
	        $('html, body').animate({
	            scrollTop: 0
	        }, 1000);
		});

		$('button.navbar-toggler').on('click', function(e) {
			let toggler = $(this);
			let targetId = $(this).data('target');
			let togglerHeight = $(targetId).outerHeight();
			let currentHeight = (togglerHeight + $(el).find('.container').first().outerHeight(true)) - 100;

			if (toggler.attr('aria-expanded') === 'false') {
				$(el).css('height', currentHeight + 'px')
				if ($(el).hasClass('scrolled-nav')) {
					$(el).removeClass('scrolled-nav')
				}
			} else {
				$(el).css('height', $(el).find('.container').first().outerHeight(true) + 'px')
				let scrollTop = $(window).scrollTop();
				if (scrollTop >= 100) {
					$(el).addClass('scrolled-nav')
				}
			}
		});
	},
	update(el) {
		let start = $('button.navbar-toggler').attr('aria-expanded');
		$(el).one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
			function(event) {
				if (start === 'true') {
					$('.navbar-toggler').addClass('collapsed')
					$('.navbar-collapse').removeClass('show')
					$('.navbar-toggler').attr('aria-expanded', 'false')
				}
			});
	}
})



// WEBPACK FOOTER //
// ./resources/assets/js/vue-directives.js